/* Foberry size charts (shirts, pants, jackets): fit tabs, in/cm switch, laid-flat / full-round switch, "Find my size",
   compare styles at one size, sideways-scroll hints, measuring-step carousel + modal.
   Plain JS, no libraries. Safe to run twice (theme editor reloads the section).
   Modes (data-fsc-mode on the .fsc root): "shirt" (default, sections/size-chart-shirts), "pants" and "jacket" (sections/size-chart-guide). */
(function () {
  'use strict';

  if (window.FoberrySizeChart) {
    window.FoberrySizeChart.initAll(document);
    return;
  }

  var CM = 2.54;
  var LS_KEY = 'fb-size-unit';
  var LS_VIEW = 'fb-size-view';
  var FIT_NAMES = { slim: 'Slim', smart: 'Smart', relaxed: 'Relaxed' }; // shirts
  var NECK_RANGE = [10, 28]; // inches, for "please check your number" only
  var CHEST_RANGE = [24, 70];
  var GUIDE = {
    pants: { r1: [20, 64], n1: 'waist', r2: [24, 72], n2: 'hip' },
    jacket: { r1: [24, 72], n1: 'chest' }
  };
  // order + wording of the rows in "compare styles"
  var ROLE_ORDER = ['waist', 'hip', 'front-rise', 'back-rise', 'thigh', 'inseam', 'length', 'bottom'];
  var ROLE_LABEL = { waist: 'Waist', hip: 'Hip', 'front-rise': 'Front rise', 'back-rise': 'Back rise', thigh: 'Thigh', inseam: 'Inseam', length: 'Total length', bottom: 'Bottom opening' };

  var reduceMotion = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };
  var instances = [];

  function lsGet(k) {
    try { return window.localStorage.getItem(k); } catch (e) { return null; }
  }
  function lsSet(k, v) {
    try { window.localStorage.setItem(k, v); } catch (e) { /* private mode */ }
  }
  function qsa(root, sel) {
    return Array.prototype.slice.call(root.querySelectorAll(sel));
  }
  function behavior() {
    return reduceMotion.matches ? 'auto' : 'smooth';
  }
  function num(v) {
    var n = parseFloat(v);
    return isNaN(n) ? 0 : n;
  }
  function trimNum(n, dp) {
    return String(+n.toFixed(dp));
  }
  function frac(v, unit) {
    return unit === 'cm' ? (v * CM).toFixed(1) : trimNum(v, 2);
  }
  function withUnit(v, unit) {
    return unit === 'cm' ? (v * CM).toFixed(1) + ' cm' : trimNum(v, 2) + '"';
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }
  // a measurement for the screen: v inches (laid flat) x mult (2 = full round) in the chosen unit
  function fmtVal(v, mult, unit) {
    return unit === 'cm' ? (v * mult * CM).toFixed(1) : trimNum(v * mult, 2);
  }

  function Chart(root) {
    this.root = root;
    // inside the product page "Fit guide" drawer: never touch the page URL (#fit-...) of the product page
    this.embed = root.classList.contains('fsc--embed');
    this.mode = root.getAttribute('data-fsc-mode') || 'shirt';
    this.unit = 'in';
    this.round = false; // pants / jackets: show full-round numbers instead of laid-flat
    this.fits = [];
    this.fit = root.getAttribute('data-default-fit') || 'smart';
    this.neckIn = null; // shirts: neck.  pants: waist.  jackets: chest.
    this.chestIn = null; // shirts: chest. pants: hip.
    this.rec = null; // { fitKey: idx }
    this.data = {};
    this.ease = {
      slim: num(root.getAttribute('data-ease-slim')),
      smart: num(root.getAttribute('data-ease-smart')),
      relaxed: num(root.getAttribute('data-ease-relaxed'))
    };
    this.init();
  }

  Chart.prototype.init = function () {
    var self = this;
    var root = this.root;

    this.tabs = qsa(root, '.fsc__tab');
    this.panels = qsa(root, '.fsc__panel');
    this.fits = this.panels.map(function (p) { return p.getAttribute('data-fit'); });
    this.readData();

    this.bar = root.querySelector('[data-fsc-bar]');
    this.form = root.querySelector('[data-fsc-form]');
    // the two finder fields: shirts = neck + chest, pants = waist + hip, jackets = chest
    this.neckInput = root.querySelector('[data-fsc-neck], [data-fsc-f1]');
    this.chestInput = root.querySelector('[data-fsc-chest], [data-fsc-f2]');
    this.errEl = root.querySelector('[data-fsc-err]');
    this.resEl = root.querySelector('[data-fsc-res]');

    if (this.fits.indexOf(this.fit) === -1) this.fit = this.fits[0] || 'smart';

    // ---- tabs
    this.tabs.forEach(function (tab) {
      tab.addEventListener('click', function () { self.selectFit(tab.getAttribute('data-fit'), { focus: false, hash: true }); });
      tab.addEventListener('keydown', function (e) { self.onTabKey(e, tab); });
    });

    // ---- unit buttons (several copies, kept in sync)
    qsa(root, '[data-fsc-unit]').forEach(function (b) {
      b.addEventListener('click', function () { self.setUnit(b.getAttribute('data-fsc-unit')); });
    });

    // ---- laid flat / full round (pants + jackets)
    qsa(root, '[data-fsc-view]').forEach(function (b) {
      b.addEventListener('click', function () { self.setView(b.getAttribute('data-fsc-view')); });
    });

    // ---- small "in / cm" switch inside the finder fields
    qsa(root, '[data-fsc-unit-toggle]').forEach(function (b) {
      b.addEventListener('click', function () { self.setUnit(self.unit === 'in' ? 'cm' : 'in'); });
    });

    // ---- column highlight by tapping a size pill
    qsa(root, '[data-fsc-pill]').forEach(function (p) {
      p.addEventListener('click', function () { self.toggleCol(p); });
    });

    // ---- find my size
    if (this.form) {
      this.form.addEventListener('submit', function (e) { e.preventDefault(); self.find(); });
      [this.neckInput, this.chestInput].forEach(function (inp) {
        if (!inp) return;
        inp.addEventListener('input', function () {
          inp.removeAttribute('aria-invalid');
          inp.removeAttribute('data-exact');
        });
      });
    }
    if (this.resEl) {
      this.resEl.addEventListener('click', function (e) {
        var card = e.target.closest ? e.target.closest('[data-fit]') : null;
        if (card && self.resEl.contains(card)) self.selectFit(card.getAttribute('data-fit'), { scroll: true, hash: true });
      });
    }

    // ---- sideways scroll hints
    qsa(root, '[data-fsc-scroll]').forEach(function (sc) {
      sc.addEventListener('scroll', function () { self.updateScroll(sc); }, { passive: true });
    });
    if (window.ResizeObserver) {
      this.ro = new ResizeObserver(function () { self.updateAllScroll(); });
      qsa(root, '[data-fsc-scroll]').forEach(function (sc) { self.ro.observe(sc); });
    }

    this.initSteps();
    this.initCompare();

    // ---- start state: saved unit + view, then hash
    var saved = lsGet(LS_KEY);
    if (saved === 'cm') this.setUnit('cm', true);
    if (this.mode !== 'shirt') {
      var hasView = !!root.querySelector('[data-fsc-view]');
      var sv = hasView ? lsGet(LS_VIEW) : null;
      var start = sv === 'round' || sv === 'flat' ? sv : root.getAttribute('data-default-view');
      this.setView(start === 'round' ? 'round' : 'flat', true);
    }
    var hashed = this.fromHash();
    this.selectFit(this.fit, { scroll: hashed });
    this.updateAllScroll();
  };

  /* ------------------------------------------------------------------ data */
  Chart.prototype.readData = function () {
    if (this.mode !== 'shirt') return this.readGuideData();
    var out = {};
    qsa(this.root, 'table[data-fit]').forEach(function (t) {
      var d = { collar: [], chest: [], sleeve: [], back: [] };
      qsa(t, 'thead [data-in]').forEach(function (el) { d.collar.push(num(el.getAttribute('data-in'))); });
      qsa(t, 'tbody tr[data-row]').forEach(function (tr) {
        var key = tr.getAttribute('data-row');
        if (!d[key]) return;
        qsa(tr, '[data-in]').forEach(function (el) { d[key].push(num(el.getAttribute('data-in'))); });
      });
      out[t.getAttribute('data-fit')] = d;
    });
    this.data = out;
  };

  // pants + jackets: sizes are labels (28, 30 ... or S, M ...), rows are found by role (waist, hip, chest ...)
  Chart.prototype.readGuideData = function () {
    var out = {};
    this.panels.forEach(function (p) {
      var key = p.getAttribute('data-fit');
      var t = p.querySelector('table[data-fit]');
      var d = {
        key: key,
        name: p.getAttribute('data-name') || key,
        tag: p.getAttribute('data-tag') || '',
        ease: num(p.getAttribute('data-ease')),
        labels: [],
        rows: {},
        roles: {},
        bumped: false
      };
      if (t) {
        qsa(t, 'thead th[data-label]').forEach(function (th) { d.labels.push(th.getAttribute('data-label')); });
        qsa(t, 'tbody tr[data-row]').forEach(function (tr) {
          var vals = [];
          qsa(tr, 'td').forEach(function (td) { vals.push(td.hasAttribute('data-in') ? num(td.getAttribute('data-in')) : null); });
          var row = { key: tr.getAttribute('data-row'), role: tr.getAttribute('data-role') || '', name: tr.getAttribute('data-name') || '', circ: tr.hasAttribute('data-circ'), vals: vals };
          d.rows[row.key] = row;
          if (row.role && !d.roles[row.role]) d.roles[row.role] = row;
        });
      }
      out[key] = d;
    });
    this.data = out;
  };

  /* ------------------------------------------------------------------ tabs */
  Chart.prototype.onTabKey = function (e, tab) {
    var i = this.tabs.indexOf(tab);
    var n = this.tabs.length;
    var next = -1;
    if (e.key === 'ArrowRight' || e.key === 'ArrowDown') next = (i + 1) % n;
    else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') next = (i - 1 + n) % n;
    else if (e.key === 'Home') next = 0;
    else if (e.key === 'End') next = n - 1;
    if (next < 0) return;
    e.preventDefault();
    this.selectFit(this.tabs[next].getAttribute('data-fit'), { focus: true, hash: true });
  };

  Chart.prototype.selectFit = function (fit, opts) {
    opts = opts || {};
    if (this.fits.indexOf(fit) === -1) return;
    this.fit = fit;
    this.tabs.forEach(function (t) {
      var on = t.getAttribute('data-fit') === fit;
      t.setAttribute('aria-selected', on ? 'true' : 'false');
      t.setAttribute('tabindex', on ? '0' : '-1');
      if (on && opts.focus) t.focus();
    });
    this.panels.forEach(function (p) {
      p.hidden = p.getAttribute('data-fit') !== fit;
    });
    // highlight the active result card
    if (this.resEl) {
      qsa(this.resEl, '[data-fit]').forEach(function (c) {
        c.classList.toggle('is-on', c.getAttribute('data-fit') === fit);
        c.setAttribute('aria-pressed', c.getAttribute('data-fit') === fit ? 'true' : 'false');
      });
    }
    this.markCompare();
    if (opts.hash && this.tabs.length > 1 && !this.embed && window.history && history.replaceState) {
      try { history.replaceState(null, '', '#fit-' + fit); } catch (e) { /* ignore */ }
    }
    this.updateAllScroll();
    this.scrollRecIntoView();
    if (opts.scroll && this.bar) {
      this.bar.scrollIntoView({ behavior: behavior(), block: 'start' });
    }
  };

  Chart.prototype.hashFit = function () {
    var m = /^#fit-([a-z0-9-]+)$/.exec(window.location.hash || '');
    return m && this.fits.indexOf(m[1]) !== -1 ? m[1] : null;
  };

  Chart.prototype.fromHash = function () {
    if (this.embed) return false;
    var f = this.hashFit();
    if (!f) return false;
    this.fit = f;
    return true;
  };

  /* ----------------------------------------------------------------- units */
  Chart.prototype.setUnit = function (unit, quiet) {
    if (unit !== 'in' && unit !== 'cm') return;
    var prev = this.unit;
    this.unit = unit;
    if (!quiet) lsSet(LS_KEY, unit);

    qsa(this.root, '[data-fsc-unit]').forEach(function (b) {
      var on = b.getAttribute('data-fsc-unit') === unit;
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    qsa(this.root, '[data-fsc-unit-label]').forEach(function (l) { l.textContent = unit; });
    qsa(this.root, '[data-fsc-unit-name]').forEach(function (l) { l.textContent = unit === 'cm' ? 'centimeters' : 'inches'; });
    qsa(this.root, '[data-fsc-unit-toggle]').forEach(function (b) {
      b.setAttribute('aria-label', unit === 'cm' ? 'Units: centimeters. Tap to switch to inches' : 'Units: inches. Tap to switch to centimeters');
    });

    this.paintCells();

    // convert what the visitor already typed
    if (prev !== unit) {
      this.convertInput(this.neckInput, prev, unit);
      this.convertInput(this.chestInput, prev, unit);
    }
    if (this.rec) this.renderResults();
    this.renderCompare();
    this.updateAllScroll();
  };

  // laid flat (as measured on the garment) <-> full round (circumference rows doubled)
  Chart.prototype.setView = function (view, quiet) {
    if (view !== 'flat' && view !== 'round') return;
    this.round = view === 'round';
    if (!quiet) lsSet(LS_VIEW, view);
    qsa(this.root, '[data-fsc-view]').forEach(function (b) {
      var on = b.getAttribute('data-fsc-view') === view;
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    this.paintCells();
    if (this.rec) this.renderResults();
    this.renderCompare();
    this.updateAllScroll();
  };

  // table numbers + size pills in the chosen unit / view
  Chart.prototype.paintCells = function () {
    var unit = this.unit;
    var round = this.round;
    qsa(this.root, '[data-in]').forEach(function (el) {
      var v = num(el.getAttribute('data-in'));
      if (el.hasAttribute('data-pill')) {
        el.textContent = withUnit(v, unit);
        return;
      }
      var tr = el.parentNode;
      var mult = round && tr && tr.hasAttribute && tr.hasAttribute('data-circ') ? 2 : 1;
      if (mult === 1) el.textContent = unit === 'cm' ? (v * CM).toFixed(1) : el.getAttribute('data-in');
      else el.textContent = fmtVal(v, mult, unit);
    });
    qsa(this.root, '[data-fsc-circ-txt]').forEach(function (l) { l.textContent = round ? 'full round' : 'laid flat'; });
  };

  Chart.prototype.convertInput = function (inp, from, to) {
    if (!inp || !inp.value.trim()) return;
    var v = parseFloat(inp.value.replace(',', '.'));
    if (isNaN(v)) return;
    // keep the exact inches so that in -> cm -> in does not drift (15.5 -> 39.4 -> 15.5)
    var inches = inp.getAttribute('data-exact') ? parseFloat(inp.getAttribute('data-exact')) : (from === 'cm' ? v / CM : v);
    inp.setAttribute('data-exact', String(inches));
    inp.value = to === 'cm' ? (inches * CM).toFixed(1) : trimNum(inches, 2);
  };

  Chart.prototype.toInches = function (v) {
    return this.unit === 'cm' ? v / CM : v;
  };

  Chart.prototype.inchesOf = function (inp, v) {
    var exact = inp && inp.getAttribute('data-exact');
    return exact ? parseFloat(exact) : this.toInches(v);
  };

  /* ------------------------------------------------------------ highlights */
  Chart.prototype.toggleCol = function (pill) {
    var th = pill.closest('th');
    var table = pill.closest('table');
    if (!th || !table) return;
    var col = th.getAttribute('data-col');
    var was = pill.getAttribute('aria-pressed') === 'true';
    qsa(table, '.is-sel').forEach(function (el) { el.classList.remove('is-sel'); });
    qsa(table, '[data-fsc-pill]').forEach(function (p) { p.setAttribute('aria-pressed', 'false'); });
    if (was) return;
    pill.setAttribute('aria-pressed', 'true');
    qsa(table, '[data-col="' + col + '"]').forEach(function (el) { el.classList.add('is-sel'); });
  };

  Chart.prototype.markRec = function () {
    var rec = this.rec;
    qsa(this.root, 'table[data-fit]').forEach(function (t) {
      qsa(t, '.is-rec').forEach(function (el) { el.classList.remove('is-rec'); });
      var idx = rec ? rec[t.getAttribute('data-fit')] : -1;
      if (typeof idx === 'number' && idx >= 0) {
        qsa(t, '[data-col="' + idx + '"]').forEach(function (el) { el.classList.add('is-rec'); });
      }
    });
  };

  Chart.prototype.scrollRecIntoView = function () {
    var panel = this.root.querySelector('.fsc__panel[data-fit="' + this.fit + '"]');
    if (!panel || panel.hidden) return;
    var sc = panel.querySelector('[data-fsc-scroll]');
    var th = panel.querySelector('thead th.is-rec');
    var first = panel.querySelector('tbody th');
    if (!sc || !th || !first || sc.scrollWidth <= sc.clientWidth + 1) return;
    var visible = sc.clientWidth - first.offsetWidth;
    var left = th.offsetLeft - first.offsetWidth - (visible - th.offsetWidth) / 2;
    sc.scrollTo({ left: Math.max(0, left), behavior: behavior() });
  };

  Chart.prototype.updateScroll = function (sc) {
    var wrap = sc.closest('[data-fsc-wrap]');
    if (!wrap) return;
    var scrollable = sc.scrollWidth > sc.clientWidth + 2;
    var end = sc.scrollLeft + sc.clientWidth >= sc.scrollWidth - 2;
    wrap.classList.toggle('is-scrollable', scrollable);
    wrap.classList.toggle('is-end', end);
    var hint = wrap.parentNode.querySelector('[data-fsc-hint]');
    if (hint) hint.hidden = !scrollable;
  };

  Chart.prototype.updateAllScroll = function () {
    var self = this;
    qsa(this.root, '[data-fsc-scroll]').forEach(function (sc) { self.updateScroll(sc); });
  };

  /* ---------------------------------------------------------- find my size */
  Chart.prototype.parse = function (inp) {
    if (!inp) return NaN;
    var raw = inp.value.trim().replace(',', '.');
    if (!raw) return NaN;
    if (!/^\d+(\.\d+)?$/.test(raw)) return -1;
    return parseFloat(raw);
  };

  Chart.prototype.showError = function (msg, inp) {
    if (this.errEl) {
      this.errEl.textContent = msg;
      this.errEl.hidden = false;
    }
    if (inp) {
      inp.setAttribute('aria-invalid', 'true');
      inp.focus();
    }
  };

  Chart.prototype.clearError = function () {
    if (this.errEl) {
      this.errEl.textContent = '';
      this.errEl.hidden = true;
    }
    [this.neckInput, this.chestInput].forEach(function (i) { if (i) i.removeAttribute('aria-invalid'); });
  };

  Chart.prototype.range = function (r) {
    var lo = this.unit === 'cm' ? Math.round(r[0] * CM) : r[0];
    var hi = this.unit === 'cm' ? Math.round(r[1] * CM) : r[1];
    return lo + '-' + hi + ' ' + this.unit;
  };

  Chart.prototype.find = function () {
    if (this.mode !== 'shirt') return this.findGuide();
    this.clearError();
    var neck = this.parse(this.neckInput);
    var chest = this.parse(this.chestInput);

    if (isNaN(neck)) return this.showError('Please enter your neck size to continue.', this.neckInput);
    var neckIn = this.inchesOf(this.neckInput, neck);
    if (neck < 0 || neckIn < NECK_RANGE[0] || neckIn > NECK_RANGE[1]) {
      return this.showError('Please check your neck size (it should be about ' + this.range(NECK_RANGE) + ').', this.neckInput);
    }
    var chestIn = null;
    if (!isNaN(chest)) {
      chestIn = this.inchesOf(this.chestInput, chest);
      if (chest < 0 || chestIn < CHEST_RANGE[0] || chestIn > CHEST_RANGE[1]) {
        return this.showError('Please check your chest size (it should be about ' + this.range(CHEST_RANGE) + ').', this.chestInput);
      }
    }

    this.neckIn = neckIn;
    this.chestIn = chestIn;
    this.compute();
    this.renderResults();
    this.markRec();
    this.selectFit(this.fit, {});
  };

  // pants (waist, optional hip) and jackets (chest)
  Chart.prototype.findGuide = function () {
    this.clearError();
    var cfg = GUIDE[this.mode] || GUIDE.pants;
    var v1 = this.parse(this.neckInput);
    var v2 = this.parse(this.chestInput);

    if (isNaN(v1)) return this.showError('Please enter your ' + cfg.n1 + ' to continue.', this.neckInput);
    var in1 = this.inchesOf(this.neckInput, v1);
    if (v1 < 0 || in1 < cfg.r1[0] || in1 > cfg.r1[1]) {
      return this.showError('Please check your ' + cfg.n1 + ' (it should be about ' + this.range(cfg.r1) + ').', this.neckInput);
    }
    var in2 = null;
    if (cfg.r2 && this.chestInput && !isNaN(v2)) {
      in2 = this.inchesOf(this.chestInput, v2);
      if (v2 < 0 || in2 < cfg.r2[0] || in2 > cfg.r2[1]) {
        return this.showError('Please check your ' + cfg.n2 + ' (it should be about ' + this.range(cfg.r2) + ').', this.chestInput);
      }
    }

    this.neckIn = in1;
    this.chestIn = in2;
    this.computeGuide();
    this.renderResults();
    this.markRec();
    // the compare table follows the size that was found
    var d = this.data[this.fit];
    var idx = this.rec[this.fit];
    if (this.cmp && d && idx >= 0 && this.cmpSizes.indexOf(d.labels[idx]) !== -1) this.cmpSize = d.labels[idx];
    this.renderCompare();
    this.selectFit(this.fit, {});
  };

  // 0.08" of slack so that a value typed in cm (rounded to 1 decimal) does not tip into the next size
  var SLACK = 0.08;
  function firstAtLeast(list, target) {
    for (var i = 0; i < list.length; i++) {
      var v = list[i];
      if (v === null || v === undefined) continue;
      if (v >= target - SLACK) return i;
    }
    return -1;
  }

  Chart.prototype.compute = function () {
    var self = this;
    var rec = {};
    this.fits.forEach(function (fit) {
      var d = self.data[fit];
      if (!d || !d.collar.length) { rec[fit] = -2; return; }
      var iN = firstAtLeast(d.collar, self.neckIn);
      var idx = iN;
      var over = iN === -1;
      if (self.chestIn !== null) {
        var iC = firstAtLeast(d.chest, self.chestIn + self.ease[fit]);
        if (iC === -1) over = true;
        else if (iC > idx) idx = iC;
      }
      rec[fit] = over ? -1 : idx;
    });
    this.rec = rec;
  };

  // full-round numbers of a row (laid-flat x 2 for the half-width rows)
  function roundRow(row) {
    return row.vals.map(function (v) { return v === null ? null : v * (row.circ ? 2 : 1); });
  }

  Chart.prototype.computeGuide = function () {
    var self = this;
    var rec = {};
    this.fits.forEach(function (key) {
      var d = self.data[key];
      if (!d || !d.labels.length) { rec[key] = -2; return; }
      d.bumped = false;
      d.bumpSteps = 0;
      d.noHip = false;
      var idx;
      var over = false;
      if (self.mode === 'jacket') {
        var chest = d.roles.chest;
        if (!chest) { rec[key] = -2; return; }
        idx = firstAtLeast(roundRow(chest), self.neckIn + d.ease);
        if (idx === -1) over = true;
      } else {
        // trouser sizes are waist sizes in inches (a 34 is made for a 34" waist) ...
        idx = firstAtLeast(d.labels.map(num), self.neckIn);
        if (idx === -1) over = true;
        // ... and a bigger hip can move the size up
        if (self.chestIn !== null) {
          var hip = d.roles.hip;
          if (!hip) {
            d.noHip = true;
          } else {
            var iH = firstAtLeast(roundRow(hip), self.chestIn + d.ease);
            if (iH === -1) over = true;
            else if (iH > idx) { d.bumpSteps = iH - idx; idx = iH; d.bumped = true; }
          }
        }
      }
      rec[key] = over ? -1 : idx;
    });
    this.rec = rec;
  };

  Chart.prototype.renderResults = function () {
    if (this.mode === 'shirt') this.renderResultsShirt();
    else this.renderResultsGuide();
  };

  Chart.prototype.renderResultsShirt = function () {
    var self = this;
    var u = this.unit;
    var html = '<div class="fsc-res__grid">';
    this.fits.forEach(function (fit) {
      var d = self.data[fit];
      var idx = self.rec[fit];
      var on = fit === self.fit ? ' is-on' : '';
      html += '<button type="button" class="fsc-res__card' + on + '" data-fit="' + fit + '" aria-pressed="' + (fit === self.fit ? 'true' : 'false') + '">';
      html += '<span class="fsc-res__fit">' + (FIT_NAMES[fit] || fit) + '</span>';
      if (idx >= 0) {
        html += '<span class="fsc-res__size">' + withUnit(d.collar[idx], u) + '</span>';
        html += '<span class="fsc-res__meta"><span>Chest ' + frac(d.chest[idx], u) + '</span><span>Sleeve ' + frac(d.sleeve[idx], u) + '</span></span>';
      } else {
        html += '<span class="fsc-res__size fsc-res__size--na">Above chart</span>';
        html += '<span class="fsc-res__meta">' + (fit === 'relaxed' ? 'Create your own size' : 'Try Relaxed') + '</span>';
      }
      html += '</button>';
    });
    html += '</div>';

    var foot;
    if (this.chestIn !== null) {
      foot = 'We add room to your chest: Slim +' + frac(this.ease.slim, u) + ', Smart +' + frac(this.ease.smart, u) + ', Relaxed +' + frac(this.ease.relaxed, u) + ' ' + u + '. Fabrics vary by about 0.5" (1.3 cm). Between two sizes? Take the larger.';
    } else {
      foot = 'Based on your neck only. Add your chest for a closer match. Fabrics vary by about 0.5" (1.3 cm).';
    }
    html += '<p class="fsc-res__foot">' + foot + ' Tap a fit to see its full table.</p>';
    this.resEl.innerHTML = html;
    this.markRec();
  };

  // two details under the big size on a result card
  Chart.prototype.metaFor = function (d, idx) {
    var self = this;
    var picks = this.mode === 'jacket' ? [['chest', 'Chest'], ['sleeve', 'Sleeve']] : [['inseam', 'Inseam'], ['bottom', 'Leg opening']];
    var out = '';
    picks.forEach(function (p) {
      var row = d.roles[p[0]];
      if (row && row.vals[idx] !== null && row.vals[idx] !== undefined) {
        out += '<span>' + p[1] + ' ' + fmtVal(row.vals[idx], row.circ && self.round ? 2 : 1, self.unit) + '</span>';
      }
    });
    if (d.bumped) out += '<span class="fsc-res__up">Sized up for your hip</span>';
    return out;
  };

  Chart.prototype.renderResultsGuide = function () {
    var self = this;
    var u = this.unit;
    var n = this.fits.length;
    var html = '<div class="fsc-res__grid fsc-res__grid--' + (n >= 4 ? 'many' : n) + '" style="--fsc-rn:' + n + '">';
    this.fits.forEach(function (key) {
      var d = self.data[key];
      var idx = self.rec[key];
      var on = key === self.fit;
      html += '<button type="button" class="fsc-res__card' + (on ? ' is-on' : '') + '" data-fit="' + esc(key) + '" aria-pressed="' + (on ? 'true' : 'false') + '">';
      html += '<span class="fsc-res__fit">' + esc(d.name) + '</span>';
      if (d.tag) html += '<span class="fsc-res__tag">' + esc(d.tag) + '</span>';
      if (idx >= 0) {
        html += '<span class="fsc-res__size">' + esc(d.labels[idx]) + '</span>';
        html += '<span class="fsc-res__meta">' + self.metaFor(d, idx) + '</span>';
      } else if (idx === -1) {
        html += '<span class="fsc-res__size fsc-res__size--na">Above chart</span><span class="fsc-res__meta">Talk to us for a custom size</span>';
      } else {
        html += '<span class="fsc-res__size fsc-res__size--na">Not listed</span>';
      }
      html += '</button>';
    });
    html += '</div>';

    var foot;
    if (this.mode === 'jacket') {
      var e0 = this.data[this.fits[0]] ? this.data[this.fits[0]].ease : 0;
      foot = 'We add ' + frac(e0, u) + ' ' + u + ' of room to your chest, so the jacket sits comfortably over a shirt.';
    } else {
      foot = 'Trouser sizes follow your waist in inches.';
      if (this.chestIn !== null) {
        foot += ' We also check your hip and go up a size when the garment hip would be smaller than yours.';
        var none = this.fits.filter(function (k) { return self.data[k].noHip; }).map(function (k) { return self.data[k].name + (self.data[k].tag ? ' (' + self.data[k].tag + ')' : ''); });
        var wide = this.fits.some(function (k) { return self.data[k].bumpSteps > 2; });
        if (wide) foot += ' Your hip is much bigger than your waist, so the waist of the bigger size may sit loose. Talk to us for a custom fit.';
        if (none.length) foot += ' ' + esc(none.join(', ')) + (none.length === 1 ? ' has' : ' have') + ' no hip measurement, so ' + (none.length === 1 ? 'it is' : 'they are') + ' matched on waist only.';
      } else {
        foot += ' Add your hip for a closer match.';
      }
    }
    foot += ' Fabrics vary by about 0.5" (1.3 cm). Between two sizes? Take the larger.';
    html += '<p class="fsc-res__foot">' + foot + ' Tap a card to see its full table.</p>';
    this.resEl.innerHTML = html;
    this.markRec();
  };

  /* ------------------------------------------------- compare styles at one size */
  Chart.prototype.initCompare = function () {
    var self = this;
    this.cmp = this.root.querySelector('[data-fsc-cmp]');
    if (!this.cmp || this.mode === 'shirt' || this.fits.length < 2) { this.cmp = null; return; }
    this.cmpSizesEl = this.cmp.querySelector('[data-fsc-cmp-sizes]');
    this.cmpTable = this.cmp.querySelector('[data-fsc-cmp-table]');
    if (!this.cmpSizesEl || !this.cmpTable) { this.cmp = null; return; }

    var seen = {};
    var sizes = [];
    this.fits.forEach(function (k) {
      self.data[k].labels.forEach(function (l) { if (!seen[l]) { seen[l] = 1; sizes.push(l); } });
    });
    var numeric = sizes.length > 0 && sizes.every(function (l) { return !isNaN(parseFloat(l)); });
    if (numeric) sizes.sort(function (a, b) { return parseFloat(a) - parseFloat(b); });
    if (!sizes.length) { this.cmp = null; return; }
    this.cmpSizes = sizes;
    this.cmpSize = sizes.indexOf('34') !== -1 ? '34' : sizes[Math.floor(sizes.length / 2)];

    sizes.forEach(function (l) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'fsc-cmp__size';
      b.setAttribute('data-size', l);
      b.setAttribute('aria-pressed', 'false');
      b.textContent = l;
      b.addEventListener('click', function () { self.cmpSize = l; self.renderCompare(); });
      self.cmpSizesEl.appendChild(b);
    });
    this.cmpTable.style.setProperty('--fsc-n', String(this.fits.length));
    this.cmpTable.addEventListener('click', function (e) {
      var b = e.target.closest ? e.target.closest('[data-fsc-cmp-fit]') : null;
      if (b) self.selectFit(b.getAttribute('data-fsc-cmp-fit'), { scroll: true, hash: true });
    });
    this.cmp.hidden = false;
    this.renderCompare();
  };

  Chart.prototype.renderCompare = function () {
    if (!this.cmp) return;
    var self = this;
    var size = this.cmpSize;
    var u = this.unit;
    qsa(this.cmpSizesEl, '.fsc-cmp__size').forEach(function (b) {
      b.setAttribute('aria-pressed', b.getAttribute('data-size') === size ? 'true' : 'false');
    });
    var roles = ROLE_ORDER.filter(function (r) {
      return self.fits.some(function (k) { return self.data[k].roles[r]; });
    });
    var h = '<caption class="fsc-sr">Measurements of every style in size ' + esc(size) + '</caption>';
    h += '<thead><tr><th scope="col" class="fsc__corner">Size ' + esc(size) + '<small data-fsc-unit-name>' + (u === 'cm' ? 'centimeters' : 'inches') + '</small></th>';
    this.fits.forEach(function (k) {
      var d = self.data[k];
      h += '<th scope="col" data-fit="' + esc(k) + '"><button type="button" class="fsc-cmp__style" data-fsc-cmp-fit="' + esc(k) + '" aria-label="Show the ' + esc(d.name + ' ' + d.tag) + ' table"><span class="fsc-cmp__n">' + esc(d.name) + '</span>' + (d.tag ? '<span class="fsc-cmp__t">' + esc(d.tag) + '</span>' : '') + '</button></th>';
    });
    h += '</tr></thead><tbody>';
    roles.forEach(function (r) {
      var circ = self.fits.some(function (k) { var row = self.data[k].roles[r]; return row && row.circ; });
      h += '<tr><th scope="row">' + ROLE_LABEL[r] + (circ ? '<small data-fsc-circ-txt>' + (self.round ? 'full round' : 'laid flat') + '</small>' : '') + '</th>';
      self.fits.forEach(function (k) {
        var d = self.data[k];
        var row = d.roles[r];
        var i = d.labels.indexOf(size);
        var v = row && i !== -1 ? row.vals[i] : null;
        if (v === null || v === undefined) h += '<td data-fit="' + esc(k) + '"><span aria-label="Not listed">&ndash;</span></td>';
        else h += '<td data-fit="' + esc(k) + '">' + fmtVal(v, row.circ && self.round ? 2 : 1, u) + '</td>';
      });
      h += '</tr>';
    });
    h += '</tbody>';
    this.cmpTable.innerHTML = h;
    this.markCompare();
    this.updateAllScroll();
  };

  Chart.prototype.markCompare = function () {
    if (!this.cmp || !this.cmpTable) return;
    var fit = this.fit;
    qsa(this.cmpTable, '[data-fit]').forEach(function (el) {
      el.classList.toggle('is-sel', el.getAttribute('data-fit') === fit);
    });
  };

  /* ------------------------------------------------- measuring steps + modal */
  Chart.prototype.initSteps = function () {
    var self = this;
    var root = this.root;
    this.stepsEl = root.querySelector('[data-fsc-steps]');
    this.modal = root.querySelector('[data-fsc-modal]');
    if (!this.stepsEl) return;

    this.stepEls = qsa(this.stepsEl, '.fsc-step');
    this.dotsEl = root.querySelector('[data-fsc-dots]');

    // dots (phones only - CSS hides them on wider screens)
    if (this.dotsEl && this.stepEls.length > 1) {
      this.dotsEl.hidden = false;
      this.stepEls.forEach(function (el, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'fsc__dot' + (i === 0 ? ' is-on' : '');
        b.setAttribute('aria-label', 'Go to step ' + (i + 1));
        b.addEventListener('click', function () {
          self.stepsEl.scrollTo({ left: Math.max(0, el.offsetLeft - self.stepPad()), behavior: behavior() });
        });
        self.dotsEl.appendChild(b);
      });
      var tick = null;
      this.stepsEl.addEventListener('scroll', function () {
        if (tick) return;
        tick = window.requestAnimationFrame(function () {
          tick = null;
          self.updateDots();
        });
      }, { passive: true });
    }

    // modal
    if (!this.modal || typeof this.modal.showModal !== 'function') return;
    this.mi = 0;
    this.stepEls.forEach(function (el, i) {
      var z = el.querySelector('[data-fsc-zoom]');
      if (z) z.addEventListener('click', function () { self.openStep(i, z); });
    });
    var q = function (s) { return self.modal.querySelector(s); };
    q('[data-fsc-close]').addEventListener('click', function () { self.modal.close(); });
    q('[data-fsc-prev]').addEventListener('click', function () { self.showStep(self.mi - 1); });
    q('[data-fsc-next]').addEventListener('click', function () { self.showStep(self.mi + 1); });
    this.modal.addEventListener('click', function (e) { if (e.target === self.modal) self.modal.close(); });
    this.modal.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); self.showStep(self.mi - 1); }
      else if (e.key === 'ArrowRight') { e.preventDefault(); self.showStep(self.mi + 1); }
    });
    this.modal.addEventListener('close', function () {
      document.documentElement.classList.remove('fsc-lock');
      if (self.lastTrigger && document.contains(self.lastTrigger)) self.lastTrigger.focus();
    });
  };

  // left padding of the swipe track (16px on the page, 12px inside the product page drawer)
  Chart.prototype.stepPad = function () {
    var v = this.stepsEl && window.getComputedStyle ? parseFloat(window.getComputedStyle(this.stepsEl).paddingLeft) : 16;
    return isNaN(v) ? 16 : v;
  };

  Chart.prototype.updateDots = function () {
    var c = this.stepsEl;
    var pad = this.stepPad();
    var dots = qsa(this.dotsEl, '.fsc__dot');
    if (!dots.length) return;
    var best = 0;
    var bestDist = Infinity;
    this.stepEls.forEach(function (el, i) {
      var d = Math.abs(el.offsetLeft - pad - c.scrollLeft);
      if (d < bestDist) { bestDist = d; best = i; }
    });
    // last card cannot reach the left edge: treat the end of the track as the last step
    if (c.scrollLeft + c.clientWidth >= c.scrollWidth - 2) best = this.stepEls.length - 1;
    dots.forEach(function (d, i) { d.classList.toggle('is-on', i === best); });
  };

  Chart.prototype.openStep = function (i, trigger) {
    this.lastTrigger = trigger;
    this.showStep(i);
    document.documentElement.classList.add('fsc-lock');
    this.modal.showModal();
  };

  Chart.prototype.showStep = function (i) {
    var n = this.stepEls.length;
    if (i < 0 || i >= n) return;
    this.mi = i;
    var el = this.stepEls[i];
    var m = this.modal;
    var q = function (s) { return m.querySelector(s); };
    var img = q('[data-fsc-m-img]');
    var src = el.getAttribute('data-img');
    var title = el.getAttribute('data-title') || '';
    if (src) {
      img.src = src;
      img.hidden = false;
    } else {
      img.hidden = true;
    }
    img.alt = title;
    q('[data-fsc-m-chip]').textContent = 'Step ' + (i < 9 ? '0' : '') + (i + 1);
    q('[data-fsc-m-title]').textContent = title;
    q('[data-fsc-m-desc]').textContent = el.getAttribute('data-desc') || el.querySelector('.fsc-step__short') && el.querySelector('.fsc-step__short').textContent || '';
    var tip = el.getAttribute('data-tip') || '';
    q('[data-fsc-m-tip]').textContent = tip;
    q('[data-fsc-m-tipbox]').hidden = !tip;
    q('[data-fsc-m-count]').textContent = (i + 1) + ' of ' + n;
    q('[data-fsc-prev]').disabled = i === 0;
    q('[data-fsc-next]').disabled = i === n - 1;
  };

  /* ----------------------------------------------------------------- boot */
  function initAll(scope) {
    scope = scope || document;
    var roots = scope.matches && scope.matches('[data-fsc]') ? [scope] : qsa(scope, '[data-fsc]');
    roots.forEach(function (r) {
      if (r.__fsc) return;
      r.__fsc = new Chart(r);
      instances.push(r.__fsc);
    });
  }

  function prune() {
    instances = instances.filter(function (c) { return document.documentElement.contains(c.root); });
  }

  window.addEventListener('hashchange', function () {
    prune();
    instances.forEach(function (c) {
      if (c.embed) return;
      var f = c.hashFit();
      if (f) c.selectFit(f, { scroll: true });
    });
  });
  window.addEventListener('resize', function () {
    prune();
    instances.forEach(function (c) { c.updateAllScroll(); });
  }, { passive: true });

  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    var r = e.target && e.target.querySelector ? e.target.querySelector('[data-fsc]') : null;
    if (r && r.__fsc && r.__fsc.ro) r.__fsc.ro.disconnect();
    document.documentElement.classList.remove('fsc-lock');
    prune();
  });

  window.FoberrySizeChart = { initAll: initAll };
  initAll(document);
})();